// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import {
  APIResource,
  type RequestOptions,
  type WithResponse,
} from "../../core";
import type { Membership, MembershipStatus, ResourceType } from "../../types";
export type ListMembershipsQueryParams = {
  offset?: number;
  limit?: number;
  kind?: ResourceType;
  status?: MembershipStatus;
  "resource.type"?: ResourceType;
  "resource.attributes.sandbox"?: boolean;
  "resource.name"?: string;
  "resource.parent.id"?: string | null;
  "resource.parent.type"?: ResourceType | null;
  roles?: string[];
};

export type ListMembershipsResponse = {
  items: Membership[];
  total_count: number;
};

/**
 * API resource for the Memberships endpoints.
 *
 * Endpoints to manage user's memberships. Memberships are used to connect the user to merchant accounts and to grant them access to the merchant's resources via roles.
 */
export class Memberships extends APIResource {
  /**
   * List memberships of the current user.
   */
  list(
    query?: ListMembershipsQueryParams,
    options?: RequestOptions,
  ): Promise<ListMembershipsResponse> {
    return this._client.get<ListMembershipsResponse>({
      path: `/v0.1/memberships`,
      query,
      ...options,
    });
  }

  listWithResponse(
    query?: ListMembershipsQueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<ListMembershipsResponse>> {
    return this._client.getWithResponse<ListMembershipsResponse>({
      path: `/v0.1/memberships`,
      query,
      ...options,
    });
  }
}
